import { useQuery } from '@tanstack/react-query'

import { getOngoingEventInfo } from '~/features/common/apis/common'

const ONGOING_EVENT_INFO_KEYS = {
  base: [{ scope: 'ongoing-event' }] as const,
  eventInfo: () =>
    [{ ...ONGOING_EVENT_INFO_KEYS.base[0], entity: 'info' }] as const,
}

export const useOngoingEventInfo = () => {
  return useQuery({
    queryKey: ONGOING_EVENT_INFO_KEYS.eventInfo(),
    queryFn: () => getOngoingEventInfo(),
  })
}
